import submit from "submit-form";

// The PublishGate of the screen, when there is one: it asks who gets a change to the steps of an
// automation that is on and has people inside
let publishGate = null;

export const registerPublishGate = (gate) => {
  publishGate = gate;
  return () => {
    if (publishGate === gate) publishGate = null;
  };
};

/**
 * Saves changes to the automation (a PUT of the API) and comes back to the same screen, or goes
 * to `returnTo`. A change to the steps of an automation that is on with people inside first asks
 * who should get it (see PublishGate).
 */
export const saveChanges = (automationId, changes, returnTo) => {
  if (publishGate?.needsAsk(changes)) {
    publishGate.ask({ automationId, changes, returnTo });
    return;
  }
  submit(`/actions/automations/${automationId}/save`, {
    method: "POST",
    body: {
      changes: JSON.stringify(changes),
      ...(returnTo && { returnTo }),
    },
  });
};

/** Sends the email of a step to the coach, with sample values. */
export const sendTestEmail = (automationId, position) =>
  submit(`/actions/automations/${automationId}/test`, {
    method: "POST",
    body: { position },
  });

// A GET form drops the query string of its action, so the params travel in the body
export const openModal = (type, params = {}) =>
  submit("/actions/refresh?", {
    method: "GET",
    body: { "modal[type]": type, ...params },
  });
